import usePartnerData from '@features/partner/hooks/usePartnerData';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { useSite } from './hooks';
import PartnerPage from './pages/PartnerPage';
import store from './store';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import { createRoot } from 'react-dom/client';
import useABTests from '@hooks/useABTests';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const PartnerRoot = ({ partner, site, miyo, design }: any) => {
  useABTests();
  usePartnerData(JSON.parse(partner), JSON.parse(miyo), JSON.parse(design));

  useSite(site);
  useEffect(() => {
    document.querySelector('#partner-module').removeAttribute('data-partner');
    document.querySelector('#partner-module').removeAttribute('data-site');
    document.querySelector('#partner-module').removeAttribute('data-miyo');
    document.querySelector('#partner-module').removeAttribute('data-design');
    window.prerenderReady = true;
  }, []);

  return <PartnerPage />;
};

const rootEl = document.getElementById('partner-module');

if (rootEl) {
  createRoot(rootEl).render(
    <ErrorBoundary>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PartnerRoot {...rootEl.dataset} />
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>
  );
}
